<template>
	<v-app dark>
		<v-main
			style="
				background-image: url('/images/background.jpg');
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;
			"
		>
			<slot />
		</v-main>
	</v-app>
</template>

<script>
export default {};
</script>